<div class="sidebar" [ngClass]="{ collapsed: isSidebarCollapsed }">
  <ul>
    <!-- Menú Inicio: siempre visible -->
    <li class="menu-category">
      <span class="menu-text" routerLink="/home" routerLinkActive="active">
        <fa-icon [icon]="['fas', 'home']"></fa-icon> Inicio
      </span>
    </li>

    <!-- Menú Personas -->
    <li class="menu-category" *ngIf="hasPermission('personas')">
      <span class="menu-text" (click)="toggleSubmenu('personasSubmenu')">
        <fa-icon [icon]="['fas', 'users']"></fa-icon> Personas
      </span>
      <ul
        class="submenu"
        [ngClass]="{ 'd-none': isSubmenuVisible('personasSubmenu') }"
      >
        <li
          routerLink="/personas"
          routerLinkActive="active"
          class="menu-section"
        >
          Gestión de Personas
        </li>
        <li
          routerLink="/titular-y-adherentes"
          routerLinkActive="active"
          class="menu-section"
        >
          Afiliados
        </li>
        <li
          routerLink="/incongruencias"
          routerLinkActive="active"
          class="menu-section"
        >
          Incongruencias - Documentos repetidos
        </li>
        <li
          routerLink="/vendedores"
          routerLinkActive="active"
          class="menu-section"
        >
          Vendedores
        </li>
        <li
          routerLink="/empresas"
          routerLinkActive="active"
          class="menu-section"
        >
          Empresas
        </li>
      </ul>
    </li>

    <!-- Menú Planes -->
    <li class="menu-category" *ngIf="hasPermission('planes')">
      <span class="menu-text" (click)="toggleSubmenu('planesSubmenu')">
        <fa-icon [icon]="['fas', 'clipboard-list']"></fa-icon> Planes
      </span>
      <ul
        class="submenu"
        [ngClass]="{ 'd-none': isSubmenuVisible('planesSubmenu') }"
      >
        <li routerLink="/planes" routerLinkActive="active" class="menu-section">
          Gestión de Planes
        </li>
      </ul>
    </li>

    <!-- Menú Usuarios -->
    <li class="menu-category">
      <span class="menu-text" (click)="toggleSubmenu('usuariosSubmenu')">
        <fa-icon [icon]="['fas', 'user']"></fa-icon> Usuarios
      </span>
      <ul
        class="submenu"
        [ngClass]="{ 'd-none': isSubmenuVisible('usuariosSubmenu') }"
      >
        <li
          routerLink="/usuarios"
          routerLinkActive="active"
          class="menu-section"
          *ngIf="hasPermission('usuarios')"
        >
          Gestión de Usuarios
        </li>
        <li
          routerLink="/usuario-editar"
          routerLinkActive="active"
          class="menu-section"
        >
          Editar Usuario
        </li>
      </ul>
    </li>

    <!-- Menú Archivos -->
    <li class="menu-category" *ngIf="hasPermission('archivos')">
      <span class="menu-text" (click)="toggleSubmenu('archivosSubmenu')">
        <fa-icon [icon]="['fas', 'archive']"></fa-icon> Archivos
      </span>
      <ul
        class="submenu"
        [ngClass]="{ 'd-none': isSubmenuVisible('archivosSubmenu') }"
      >
        <li
          routerLink="/subir-archivo"
          routerLinkActive="active"
          class="menu-section"
        >
          Subir archivo
        </li>
        <li
          routerLink="/persona-comparacion"
          routerLinkActive="active"
          class="menu-section"
        >
          Resolver conflictos de datos
        </li>
      </ul>
    </li>

    <!-- Menú Reportes -->
    <!--  <li class="menu-category" *ngIf="hasPermission('reportes')">
      <span class="menu-text" (click)="toggleSubmenu('reporteSubmenu')">
        <fa-icon [icon]="['fas', 'chart-bar']"></fa-icon> Reportes
      </span>
      <ul
        class="submenu"
        [ngClass]="{ 'd-none': isSubmenuVisible('reporteSubmenu') }"
      >
        <li
          (click)="abrirVentana('reporteTitularesSinDj')"
          class="menu-section"
        >
          Generar reporte de titulares activos sin DJ
        </li>
      </ul>
    </li>
 -->
    <!-- Menú Gestos -->
    <li class="menu-category" *ngIf="hasPermission('gestos')">
      <span class="menu-text" (click)="toggleSubmenu('gestosSubmenu')">
        <fa-icon [icon]="['fas', 'file-export']"></fa-icon> Gestos
      </span>
      <ul
        class="submenu"
        [ngClass]="{ 'd-none': isSubmenuVisible('gestosSubmenu') }"
      >
        <li
          (click)="abrirVentana('exportarArchivosCompletos')"
          class="menu-section"
        >
          Padron Completo
        </li>
        <li
          (click)="abrirVentana('exportarArchivosAltas')"
          class="menu-section"
        >
          Altas
        </li>
        <li
          routerLink="/codigo-gestos"
          routerLinkActive="active"
          class="menu-section"
        >
          Codigo gestos
        </li>
      </ul>
    </li>
  </ul>
  <div class="version-info">
    <span>Version API: {{ apiVersion }} - {{ apiDateVersion }}</span>
    <hr class="thin-line" />
    <span>Version APP: {{ appVersion }} - {{ appDateVersion }}</span>
    <hr class="thin-line" />
    <span>Version DB: {{ dbVersion }} - {{ dbDateVersion }}</span>
  </div>
</div>

<div *ngIf="getEstadoVentana('reporteTitularesSinDj')" class="report-dialog">
  <h3>Generar Reporte</h3>
  <form (ngSubmit)="generarReporteTitularesSinDj()">
    <div class="form-group">
      <label for="meses">Cantidad de meses: &nbsp;</label>
      <input
        type="number"
        id="meses"
        class="inputMeses"
        [(ngModel)]="meses"
        name="meses"
        required
        min="1"
      />
    </div>
    <button type="submit" class="btn btn-success">Generar</button>
    <button
      type="button"
      (click)="cerrarVentana('reporteTitularesSinDj')"
      class="btn btn-secondary ms-2"
    >
      Cancelar
    </button>
  </form>
</div>

<div
  *ngIf="getEstadoVentana('exportarArchivosCompletos')"
  class="report-dialog"
>
  <h3>Generar Archivo Completo</h3>
  <form (ngSubmit)="exportarArchivosCompletos()">
    <button type="submit" class="btn btn-success">Exportar</button>
    <button
      type="button"
      (click)="cerrarVentana('exportarArchivosCompletos')"
      class="btn btn-secondary ms-2"
    >
      Cancelar
    </button>
  </form>
</div>

<div *ngIf="getEstadoVentana('exportarArchivosAltas')" class="report-dialog">
  <h3>Generar Archivo de Altas</h3>
  <form (ngSubmit)="exportarArchivos('altas', fechaDesde, fechaHasta)">
    <div class="form-group">
      <label for="fechaDesde">Fecha Desde: &nbsp;</label>
      <input
        type="date"
        id="fechaDesde"
        class="inputFecha"
        [(ngModel)]="fechaDesde"
        name="fechaDesde"
        required
      />
      <label for="fechaHasta">Fecha Hasta: &nbsp;</label>
      <input
        type="date"
        id="fechaHasta"
        class="inputFecha"
        [(ngModel)]="fechaHasta"
        name="fechaHasta"
        required
      />
    </div>
    <button type="submit" class="btn btn-success">Exportar</button>
    <button
      type="button"
      (click)="cerrarVentana('exportarArchivosAltas')"
      class="btn btn-secondary ms-2"
    >
      Cancelar
    </button>
  </form>
</div>
